<template>
<li class="flex py-6">
<div class="shrink-0">
<img :src="cartItem.thumbnail_url" :alt="cartItem.title" class="w-20 rounded-md" />
</div>

<div class="ml-6 flex flex-1 flex-col">
<div class="flex">
    <div class="min-w-0 flex-1">
    <h4 class="text-sm text-left">
        <span class="font-bold text-black pr-2"  v-if="(cartItem.type == 'ticket')">TICKET</span>
        <a href="#" class="font-medium text-black hover:text-gray-800">{{ cartItem.title }}</a>
    </h4>
    </div>

    <div class="ml-4 flow-root shrink-0" v-if="(cartView == false)">
    <button @click.prevent="removeItem" type="button" class="-m-2.5 flex items-center justify-center bg-white p-2.5 text-gray-400 hover:text-gray-500">
        <span class="sr-only">Verwijder</span>
        <TrashIcon class="size-5" aria-hidden="true" />
    </button>
    </div>
</div>
<div class="flex flex-1 items-end justify-between pt-2">
  <p class="mt-1 text-sm font-medium text-gray-900">{{ $filters.toCurrency(cartItem.price) }}/stuk</p>
  <p class="mt-1 text-sm font-xl text-gray-900"  v-if="(cartView == true)">aantal: {{ cartItem.quantity }}</p>
  <p class="mt-1 text-sm font-xl text-gray-900">subtotaal: {{ $filters.toCurrency(subtotal) }}</p>
</div>
<div class="flex flex-1 items-end justify-end pt-4"  v-if="(cartView == false)">
    <div class="max-w">
        <input type="number" class="form-control w-full text-center"
          :value="cartItem.quantity"
          @input="updateQuantity"
          min="0">
    </div>
</div>
</div>
</li>
</template>
<script>
import { mapActions } from 'vuex'
import { TrashIcon } from '@heroicons/vue/16/solid'

export default {
	name: 'Cart Product Tile',
	props: {cartItem: Object, cartView: Boolean},
  components: { TrashIcon },
  computed: {
			subtotal() {
				return this.cartItem.quantity * this.cartItem.price;
			}
	},
	methods: {
    ...mapActions(['updateCart', 'removeItemInCart']),
    removeItem() {
				let vm = this;
				this.removeItemInCart({
					item: vm.cartItem
				});
		},
    updateQuantity(event) {
        let qty = event.target.value;  
        qty = (qty == "") ? 0 :  parseInt(qty);
        
				let vm = this;
				this.updateCart({
					item: vm.cartItem,
					quantity: qty,
					isAdd: false
				});
		} 
  }
};
</script>